import { render, staticRenderFns } from "./taskConfiguration.vue?vue&type=template&id=5b9feaa9&scoped=true&"
import script from "./taskConfiguration.vue?vue&type=script&lang=js&"
export * from "./taskConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./taskConfiguration.vue?vue&type=style&index=0&id=5b9feaa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9feaa9",
  null
  
)

export default component.exports